var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-center"},[_vm._v("Plantilla de contrato para Maestrias")]),_vm._m(0),_c('hr'),_c('v-row',[_c('v-col',[_c('vue-editor',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-center"},[_c('b',[_vm._v("Use las palabras {clave} para ubicar los textos reemplazables")])])
}]

export { render, staticRenderFns }